import React, { useContext, useEffect, useState } from "react";
import NewButton from "./NewButton";
import { ReactComponent as CHECK } from "../assets/icons/check.svg";
import { ReactComponent as Close } from "../assets/icons/x.svg";
import { ReactComponent as COPY } from "../assets/icons/copy.svg";
import { NotificationContext } from "../Context/NotificationContext";
import copy from "copy-to-clipboard";
import axios from "axios";
import { DataContext } from "../Context/DataContext";
import "./SendPaymentLinkPopUp.css";
import { firestore, getFullHttpUrl, websiteUrl } from "../firebase.config";
import { EAST4 } from "../utility/enums";
import { v4 as uuidv4 } from 'uuid';

const SendPaymentLinkPopUp = ({ onClose, id, type, data, isPaymentLink = true, customLink = "/" }) => {
  const [sendEmail, setSendEmail] = useState("");
  const [btnText, setBtnText] = useState("Send");
  const [linkCopy, setLinkCopy] = useState(false);
  // const [prevEmails, setPrevEmails] = useState([]);
  const [prevData, setPrevData] = useState([]);
  const [cooldowns, setCooldowns] = useState({});
  const [documentID, setDocumentID] = useState("");

  const paymentLink = isPaymentLink ? `${websiteUrl}/make-payment/${
    type + "/" + id || ""
  }` : customLink;
  const { userData } = useContext(DataContext);
  const { showNotification } = useContext(NotificationContext);


  const fetchSharedLinkEmails = () => {
    // docID is teamId or userID
    const docID = userData ? userData.teamId?? userData.id : uuidv4();
    setDocumentID(docID);
    firestore.collection("sharedLinkEmails").doc(docID).get().then((doc) => {
      if(!doc.exists){
        // setPrevEmails([]);
        setCooldowns({});
        return;
      }
      const storedData = doc.data().storedData;
      localStorage.setItem("sharedLinkEmails", JSON.stringify(storedData));
      const entry = storedData.find((entry) => entry.id === id);
      // setPrevEmails(entry ? entry.emails : []);
      setPrevData(storedData);
  
      const cooldownData = doc.data().cooldownData || {};
      localStorage.setItem("resendCooldowns", JSON.stringify(cooldownData));
      setCooldowns(cooldownData || {}); // Load cooldowns specific to this invoice ID
    });
  }

  useEffect(() => {
    fetchSharedLinkEmails();
  }, [userData, id]);

  useEffect(() => {
    const interval = setInterval(updateCooldowns, 1000);
    return () => clearInterval(interval);
  }, []);

  const emailRegex =
    /^[a-zA-Z0-9._+%-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\.?[a-z]{2})?$/;

  const handleSend = (email, isResend = false, link = paymentLink) => {
    if (!emailRegex.test(email)) {
      showNotification("Error", "Please enter a valid email.", "error");
      return;
    }

    if (!isResend) {
      for (let linkData of prevData) {
        if(linkData.emails.some(e => e.email === email && linkData.paymentLink === link)){
          
          showNotification(
            "Error",
            "Payment Link has already been sent to this email.",
            "error"
          );
          setSendEmail("");
          return;
        }
      }
    }

    setBtnText("Sending...");

    axios({
      method: "post",
      url: getFullHttpUrl("emails-sendPaymentLink", EAST4),
      data: {
        email: email,
        name: userData.name,
        data: data,
        type: type,
        link: link,
        senderEmail: userData.email,
      },
    })
      .then(() => {
        showNotification(
          "Payment Link Sent",
          `Payment link sent to ${email}.`,
          "success"
        );
        handleSaveEmail(email, isResend, link);
        setBtnText("Send");
        setSendEmail("");
      })
      .catch(() => {
        showNotification(
          "Error",
          "Error sending the payment link. Please try again.",
          "error"
        );
      });
  };

  const handleCopyLink = () => {
    copy(paymentLink);
    setLinkCopy(true);
    showNotification(
      "Link Copied",
      "The Payment Link has been copied to the clipboard.",
      "success"
    );
  };

  const handleSaveEmail = async(email, isResend = false, link = paymentLink) => {
    let storedData = JSON.parse(localStorage.getItem("sharedLinkEmails")) || [];
    let existingEntry = storedData.find((entry) => entry.id === id);

    if (existingEntry) {
      // Check if the email already exists
      const emailIndex = existingEntry.emails.findIndex(
        (e) => e.email === email
      );

      if (emailIndex !== -1) {
        existingEntry.emails[emailIndex].timestamp = Date.now();
      } else {
        existingEntry.emails.push({ email, timestamp: Date.now() });
      }
      existingEntry.paymentLink = link;
    } else {
      storedData.push({ id, emails: [{ email, timestamp: Date.now() }], paymentLink: link });
    }

    localStorage.setItem("sharedLinkEmails", JSON.stringify(storedData));
    if(isResend){
      await firestore.collection("sharedLinkEmails").doc(documentID).update({storedData});
    }else{
      const docID = documentID ? documentID : userData ? userData.teamId?? userData.id : uuidv4();
      await firestore.collection("sharedLinkEmails").doc(docID).set(
        {storedData}
      );

    }
    fetchSharedLinkEmails();
    
    // setPrevEmails([...storedData.find((entry) => entry.id === id).emails]);
  };

  const startResendCooldown = (email, coolDownID) => {
    
    let cooldownData =
      JSON.parse(localStorage.getItem("resendCooldowns")) || {};

    if (!cooldownData[coolDownID]) {
      cooldownData[coolDownID] = {};
    }

    cooldownData[coolDownID][email] = Date.now() + 30 * 60 * 1000;

    localStorage.setItem("resendCooldowns", JSON.stringify(cooldownData));
    firestore.collection("sharedLinkEmails").doc(documentID).update({cooldownData});

    setCooldowns(cooldownData);
  };

  const updateCooldowns = () => {
    let cooldownData =
      JSON.parse(localStorage.getItem("resendCooldowns")) || {};
      // console.log("cooldowns", cooldownData)
    let updatedCooldowns = {};

      Object.keys(cooldownData).forEach((itemID) => {
        Object.keys(cooldownData[itemID]).forEach((email) => {
          if (cooldownData[itemID][email] > Date.now()) {
          updatedCooldowns[email] = cooldownData[itemID][email];
        }
        });
        cooldownData[itemID] = updatedCooldowns;
      });

      // console.log("updatedCooldowns", updatedCooldowns)
      setCooldowns(cooldownData);
      localStorage.setItem("resendCooldowns", JSON.stringify(cooldownData));
  };

  const canResend = (email, itemID) => { 
    if(cooldowns[itemID]){
      return !cooldowns[itemID][email] || cooldowns[itemID][email] < Date.now();
    }
    return true;
    // return !cooldowns[id][email] || cooldowns[id][email] < Date.now();
  };

  const getTimeLeft = (email, itemID) => {
    const timeLeft = cooldowns[itemID][email] - Date.now();
    if (timeLeft > 0) {
      const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
      const seconds = Math.floor((timeLeft / 1000) % 60);
      return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    }
    return null;
  };

  const groupEmailsByDay = () => {
    const groupedEmails = {};
    prevData.filter(data => data.id === id).forEach(linkData => {

      linkData.emails.forEach(({ email, timestamp }) => {
        const dayLabel = getTimeAgo(timestamp);
        if (!groupedEmails[dayLabel]) {
          groupedEmails[dayLabel] = [];
        }
        groupedEmails[dayLabel].push({email, link: linkData.paymentLink, id: linkData.id});
      });
    })

    return groupedEmails;
  };


  const getTimeAgo = (timestamp) => {
    const now = new Date();
    const sentDate = new Date(timestamp);
    const diffInDays = Math.floor((now - sentDate) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    return `${diffInDays} days ago`;
  };

  return (
    <div className="newPopUpModalWrap" style={{zIndex: 1002}}>
      <div className="sendPaymentModalContainer">
        <h2 className="newPopUpModalTitle">Share Payment Link</h2>
        <p className="newPopUpModalSubText">
          Copy payment link or share it via email.
        </p>

        <div className="sendPaymentModalTextWrap" style={{ cursor: "pointer" }}>
          <p className="newPopUpModalText sendPaymentLink">{paymentLink}</p>
          {!linkCopy ? (
            <div onClick={handleCopyLink}>
              <COPY />
            </div>
          ) : (
            <div className="flex items-center gap-2 text-[14px] font-weight-[400]">
              <p>Copied </p>
              <span style={{ border: "1px solid black", borderRadius: "50%" }}>
                <CHECK className="max-w-[12px] max-h-[12px]" />
              </span>
            </div>
          )}
        </div>

        <div className="sendPaymentModalTextWrap">
          <input
            className="accountDetailsSearchInput"
            placeholder="Enter Email"
            value={sendEmail}
            onChange={(e) => setSendEmail(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend(sendEmail)}
            autoFocus
          />
          <NewButton
            disabled={!emailRegex.test(sendEmail) || btnText === "Sending..."}
            text={btnText}
            width="90px"
            onClick={() => handleSend(sendEmail)}
          />
        </div>

        <div className="customScroll w-full max-h-[300px] overflow-y-auto pr-[10px] flex flex-col justify-start items-start gap-2">
          {Object.entries(groupEmailsByDay()).map(([day, emailsData], index) => (
            <div key={index} className="paymentHistoryBox">
              <p className="subTitle text-start">Last Shared: {day}</p>
              {emailsData.map((emailData, idx) => (
                <div key={idx} className="flex justify-between">
                  <div className="flex flex-col justify-start items-start gap-[2px]">
                    <p>{emailData.email}</p>
                    {/* {emailData.link && <p className="text-[12px] text-[#666666]">{emailData.link.split(".com/").pop()}</p>} */}
                  </div>
                  {canResend(emailData.email, emailData.id) ? (
                    <p
                      style={{
                        color: "#12ABBF",
                        fontFamily: "Inter",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => {
                        handleSaveEmail(emailData.email);
                        handleSend(emailData.email, true, emailData.link);
                        startResendCooldown(emailData.email, emailData.id);
                      }}
                    >
                      Resend
                    </p>
                  ) : (
                    <div className="flex justify-between gap-2">
                      <p>Resend in:</p>
                      <span
                        style={{
                          color: "#030F23",
                          fontWeight: "500",
                          maxWidth: "40px",
                        }}
                      >
                        {getTimeLeft(emailData.email, emailData.id)}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        <Close className="newPopUpModalCloseIcon" onClick={onClose} />
      </div>
    </div>
  );
};

export default SendPaymentLinkPopUp;
